import { ReactElement, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import LoginForm from 'containers/LoginForm';
import { resetToken } from 'store/oauth/actions';

const Login = (): ReactElement => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(resetToken());
  }, [dispatch]);

  return <LoginForm />;
};

export default Login;
